import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import { Box, Input } from 'core/ui/atoms';
import { EditHeading, EditBlock } from 'days/ui/atoms';

import withUpdateNight from 'nights/ui/withUpdateNight';

@withUpdateNight
class NightName extends PureComponent {
  static propTypes = {
    name: PropTypes.string,
    updateNight: PropTypes.func,
  };

  state = {
    name: this.props.name || '',
  };

  save = debounce(() => {
    const { name } = this.state;
    this.props.updateNight({ name })
  }, 1000);

  handleChange = (e) => {
    this.setState({ name: e.target.value });
    this.save();
  };

  render() {
    const { name } = this.state;
    return (
      <EditBlock>
        <Box width="100%">
          <EditHeading>Название:</EditHeading>
          <Input type="text" value={name} onChange={this.handleChange}/>
        </Box>
      </EditBlock>
    );
  }
}

export default NightName;
